import axios from '../../http';

import router from '../../routes';

const state = {
  result: {
    request: {
      address: {
        propertyType: null
      },
      current: null,
      compare: null,
      ashp: {
        ashpSize: null,
        heatingFuel: null
      }
    },
    calculatedResults: []
  },
  currentTariff: {},
  ashpDetails: null,
  currentEv: null,
  currentIce: null
};

const getters = {
  calculatedResult: (state) => {
    return (state.result.calculatedResults || []).find(
      ({ isCurrent }) => !isCurrent
    );
  }
};

const actions = {
  async getQuoteResults({ state, rootState, commit, dispatch }) {
    const { quote } = rootState.session;

    dispatch('page_loader/start', 0, { root: true });
    dispatch('page_loader/quoteLoader', null, { root: true });

    try {
      const { data, status } = await axios({
        method: 'GET',
        url: `/request/results/tou/esa/${quote.quoteType}/result`,
        params: {
          quoteId: quote.switchId
        }
      });

      if (status == 200) {
        commit('updateState', {
          prop: 'result',
          value: addCalculations(data, quote.quoteType)
        });
      }

      return data;
    } catch (error) {
      return error;
    } finally {
      dispatch('page_loader/stop', null, { root: true });
    }
  },
  async solarRecalculate({ state, rootState, commit, dispatch }, result) {
    const { results } = state;
    const res = await axios({
      method: 'POST',
      url: '/request/results/tou/solar/update',
      data: result
    });

    const newResults = results.map((item) => {
      item.breakDown.electricity = item.breakDown.electricity.map((e) => ({
        ...e,
        show: false
      }));
      item.breakDown.gas = item.breakDown.gas.map((g) => ({
        ...g,
        show: false
      }));

      if (item.tariffId == result.tariffId) {
        return res.data;
      }

      return item;
    });

    commit('updateState', {
      prop: 'results',
      value: newResults
    });
  },
  async heatPumpRecalculate({ state, rootState, commit, dispatch }, result) {
    const { results } = state;
    const res = await axios({
      method: 'POST',
      url: '/request/results/tou/ashp/update',
      data: result
    });

    const newResults = results.map((item) => {
      item.breakDown.electricity = item.breakDown.electricity.map((e) => ({
        ...e,
        show: false
      }));
      item.breakDown.gas = item.breakDown.gas.map((g) => ({
        ...g,
        show: false
      }));

      if (item.tariffId == result.tariffId) {
        return res.data;
      }

      return item;
    });

    commit('updateState', {
      prop: 'results',
      value: newResults
    });
  },
  async enquire({}, data) {
    const res = await axios({
      method: 'POST',
      url: '/request/customer/esa/enquiry',
      data
    });
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

function addCalculations(data, type) {
  if (type == 'solar') {
    data.calculatedResults = data.calculatedResults.map((item) => {
      if (item.isCurrent == false) {
        const { solarUsedInHouse, solarGeneration, exportedToGrid } =
          item.electricity;
        const made = solarUsedInHouse / solarGeneration;
        const sell = exportedToGrid / solarGeneration;

        return {
          ...item,
          electricity: {
            ...item.electricity,
            percentageMade: made * 100,
            percentageSell: sell * 100,
            madeKwh: made * solarGeneration,
            sellKwh: sell * solarGeneration
          }
        };
      }

      return item;
    });
  }

  // if(type == 'ev') {

  // }

  // if(type == 'ashp') {

  // }

  return data;
}
